var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "shopCheck" }, [
    _c("ul", [
      _c(
        "li",
        [
          _c("h1", [_vm._v("订到")]),
          _c("p", { staticClass: "f16" }, [_vm._v("无需开店，一键开通")]),
          _c("p", { staticClass: "f14" }, [
            _vm._v("适用于线下转为线上，便捷订货系统")
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.openShop(0)
                }
              }
            },
            [_vm._v("立即开通")]
          )
        ],
        1
      ),
      _c(
        "li",
        [
          _c("h1", [_vm._v("网店")]),
          _c("p", { staticClass: "f16" }, [
            _vm._v("享受电商全功能，货品卖全国")
          ]),
          _c("p", { staticClass: "f14" }, [
            _vm._v(
              "一站式管理网店的店铺装修、商品、订单、营销、会员、资金等数据。"
            )
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.openShopNew()
                }
              }
            },
            [_vm._v("开通网店")]
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "shopCheck_bottom" }, [
      _vm._v("不知道选哪个？欢迎拨打咨询热线：400-810-5353")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }